import { render, staticRenderFns } from "./MarkClassificationAsDone.vue?vue&type=template&id=70e33538&scoped=true"
import script from "./MarkClassificationAsDone.vue?vue&type=script&lang=js"
export * from "./MarkClassificationAsDone.vue?vue&type=script&lang=js"
import style0 from "./MarkClassificationAsDone.vue?vue&type=style&index=0&id=70e33538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e33538",
  null
  
)

export default component.exports